import React from 'react';

import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import CheckBox from 'devextreme-react/check-box';
import DateBox from 'devextreme-react/date-box';

import DateTimeUtils from '../../common/utils/DateTimeUtils';

import notify from 'devextreme/ui/notify';
import DataModelView from '../../common/view/DataModelView';

import './ScheduleDateRangePopup.css';

export default class ScheduleDateRangePopup extends DataModelView {
	getIntegratedPropertyNames() {
		return [
			'popupSessionId',
			'popupTitle',
			'popupVisible',
			'availableContracts',
			'selectedContracts',
			'rangeFirstDate',
			'rangeLastDate',
			'submitPrinceTrades',
			'submitSata',
			'requireSubmissionType',
			'commandType',
			'commandLabel',
			'commandIcon'
		];
	}

	render() {
		return <Popup
			visible={this.state.popupVisible}
			title={this.state.popupTitle}
			showTitle={true}
			showCloseButton={false}
			hideOnOutsideClick={true}
			width="460px"
			height="auto"
		>
			<Position
				at="middle"
				my="center"
				collision="fit"
			/>
			{this.renderContractSelection()}
			<br></br>
			{this.renderPopUpCalendarRange()}
			<br></br>
			{this.renderSubmissionType()}
			<ToolbarItem
				widget="dxButton"
				toolbar="bottom"
				location="before"
				disabled={!(this.state.rangeFirstDate && this.state.rangeLastDate)}
				options={{
					type: this.state.commandType,
					icon: this.state.commandIcon,
					text: this.state.commandLabel,
					onClick: this.validateOnContinue.bind(this),
				}}
			/>
			<ToolbarItem
				widget="dxButton"
				toolbar="bottom"
				location="after"
				options={{
					icon: 'close',
					text: 'Close',
					onClick: this.props.onCancel,
				}}
			/>
		</Popup>
	}

	renderContractSelection() {
		return <>
			<div className="pwx-popup-section-header">
				Include the following contracts:
			</div>
			{
				this.state.availableContracts.map(contract => (
					<div key={this.state.popupSessionId + ':' + contract.code}>
						<CheckBox
							className="pwx-popup-checkbox"
							onValueChanged={this.onContractToggleCheck.bind(this, contract)}
							text={contract.displayName + ' (' + contract.code + ')'}
							defaultValue={this.state.selectedContracts.indexOf(contract) !== -1}
						/>
					</div>
				))
			}
		</>;
	}

	renderPopUpCalendarRange() {
		return <>
			<div className="pwx-popup-section-header">
				Select a range of dates for this operation:
			</div>
			<div>
				<table><tbody>
					<tr>
						<td>
							<div className="pwx-popup-datebox-label">Start Date:</div>
						</td>
						<td>
							<DateBox
								className="pwx-popup-datebox"
								type="date"
								showClearButton={false}
								defaultValue={this.now}
								value={this.state.rangeFirstDate}
								onValueChanged={this.onRangeStartChange.bind(this)}
								width="125px"
							/>
						</td>
						<td>
							<div className="pwx-popup-datebox-interspacing" />
						</td>
						<td>
							<div className="pwx-popup-datebox-label">End Date:</div>
						</td>
						<td>
							<DateBox
								className="pwx-popup-datebox"
								type="date"
								showClearButton={false}
								defaultValue={this.now}
								value={this.state.rangeLastDate}
								onValueChanged={this.onRangeEndChange.bind(this)}
								width="125px"
							/>
						</td>
					</tr>
				</tbody></table>
			</div>
		</>
	}

	renderSubmissionType() {
		return <>
			<div className="pwx-popup-section-header">
				Submit data for:
			</div>
			<div>
				<table><tbody>
					<tr>
						<td>
							<CheckBox
								key={this.state.popupSessionId + ':SubmitPrinceTrades'}
								className="pwx-popup-checkbox"
								onValueChanged={this.onSubmitPrinceTradesToggleCheck.bind(this)}
								text="Prince Trades"
								defaultValue={this.state.submitPrinceTrades}
							/>
						</td>
						<td>
							<div className="pwx-popup-checkbox-interspacing" />
						</td>
						<td>
							<CheckBox
								key={this.state.popupSessionId + ':SubmitSata'}
								className="pwx-popup-checkbox"
								onValueChanged={this.onSubmitSataToggleCheck.bind(this)}
								text="Schedule & Tag Adjust (SATA)"
								defaultValue={this.state.submitSata}
							/>
						</td>
					</tr>
				</tbody></table>
			</div>

		</>;
	}

	onContractToggleCheck(contract, e) {
		var contractIndex = this.state.selectedContracts.indexOf(contract);

		if (e.event === undefined)
			e.value = e.previousValue;

		if (contractIndex === -1 && e.value) {
			this.state.selectedContracts.splice(0, 0, contract);
		} else if (contractIndex !== -1 && !e.value) {
			this.state.selectedContracts.splice(contractIndex, 1);
		}
	}

	onSubmitPrinceTradesToggleCheck(e) {
		if (e.event === undefined)
			e.value = e.previousValue;

		this.dataModel.updateProperties({
			submitPrinceTrades: e.value
		});
	}

	onSubmitSataToggleCheck(e) {
		this.dataModel.updateProperties({
			submitSata: e.value
		});
	}

	onRangeStartChange(e) {
		this.props.dataModel.updateProperties({
			rangeFirstDate: e.value
		});
	}

	onRangeEndChange(e) {
		this.props.dataModel.updateProperties({
			rangeLastDate: e.value
		});
	}

	validateOnContinue() {
		if (this.isValidContractSelection() && this.isValidDateRange() && this.isValidSubmissionTypeSelection())
			this.props.onContinue();
	}

	isValidContractSelection() {
		if (this.state.selectedContracts.length === 0) {
			notify('At least one contract should be selected.', 'error', 3000);
			return false;
		}

		return true;
	}

	isValidDateRange() {
		if (DateTimeUtils.getMonth(this.state.rangeFirstDate).valueOf() !== DateTimeUtils.getMonth(this.state.rangeLastDate).valueOf()) {
			notify('The \'Start Date\' and \'End Date\' values should be in the same month.', 'error', 3000);
			return false;
		}

		if (this.state.rangeFirstDate > this.state.rangeLastDate) {
			this.props.dataModel.updateProperties({
				endDate: this.state.rangeFirstDate
			});

			notify('The \'Start Date\' should precede the \'End Date\'.', 'error', 3000);
			return false;
		}

		return true;
	}

	isValidSubmissionTypeSelection() {
		if (!this.state.requireSubmissionType)
			return true;

		if (!this.state.submitPrinceTrades && !this.state.submitSata) {
			notify('At least one data submission type should be selected.', 'error', 3000);
			return false;
		}

		return true;
	}
}